import PropTypes from 'prop-types'
import React from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import DtoUserCmsStatistic from '../../../user/dto/DtoUserCmsStatistic'
import DtoUserStationStatistic from '../../../user/dto/DtoUserStationStatistic'
import DtoUserStatistic from '../../../user/dto/DtoUserStatistic'
import DtoUserUsageStatistic from '../../../user/dto/DtoUserUsageStatistic'
import AccessChartPanel from './charts/AccessChartPanel'
import CmsStatisticsPanel from './statistic/CmsStatisticsPanel'
import StationStatisticsPanel from './statistic/StationStatisticsPanel'
import StatisticsPanel from './statistic/StatisticsPanel'
import UsageStatisticsPanel from './statistic/UsageStatisticsPanel'
import { Grid, Stack } from '@mui/material'
import User from '../../../../../account/dto/User'
import useActions from 'utils/customHook/useActions'

const UserStatisticPanel = () => {
    const {
        userStatistics,
        userCmsStatistics,
        userUsageStatistics,
        userStationStatistics,
    } = useSelector(store => ({
        userStatistics: store.UserReducer.userStatistics,
        userCmsStatistics: store.UserReducer.userCmsStatistics,
        userUsageStatistics: store.UserReducer.userUsageStatistics,
        userStationStatistics: store.UserReducer.userStationStatistics,
    }), shallowEqual)

    useActions(() => [], [])

    return (
        <Stack spacing={1}>
            <Grid container size={12} spacing={1}>
                <Grid size={8}>
                    <AccessChartPanel
                        userStatistics={userStatistics}
                    />
                </Grid>
                <Grid size={4}>
                    <StatisticsPanel
                        userStatistics={userStatistics}
                    />
                </Grid>
            </Grid>
            <UsageStatisticsPanel
                userUsageStatistics={userUsageStatistics}
            />
            <StationStatisticsPanel
                userStationStatistics={userStationStatistics}
            />
            <CmsStatisticsPanel
                userCmsStatistics={userCmsStatistics}
            />
        </Stack>
    )
}

UserStatisticPanel.propTypes = {
    user: PropTypes.instanceOf(User),
    userStatistics: PropTypes.arrayOf(PropTypes.instanceOf(DtoUserStatistic)),
    userCmsStatistics: PropTypes.arrayOf(PropTypes.instanceOf(DtoUserCmsStatistic)),
    userUsageStatistics: PropTypes.arrayOf(PropTypes.instanceOf(DtoUserUsageStatistic)),
    userStationStatistics: PropTypes.arrayOf(PropTypes.instanceOf(DtoUserStationStatistic)),
}

export default UserStatisticPanel
